import { Box, Theme, styled } from '@mui/material';

interface CardContainerProps {
  hasActionItems: boolean;
}
export const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasActionItems',
})<CardContainerProps>(({ hasActionItems }) => ({
  padding: hasActionItems ? '12px 16px 0px 16px' : '24px 16px 0px 16px', // TODO => update to theme spacing
  backgroundColor: 'drawerNavigation.main',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  '&:hover': {
    background: ({ palette }: Theme) => palette.background.main,
  },
}));
